export default{
    install(Vue){
        Vue.prototype.ifNull = (value) =>{
            const reg = /^\s+$/gi;
            if(typeof value == 'undefined' || value == null || value == '' || reg.test(value)){
                return true;
            }else {
                return false;
            }
        };
        Vue.prototype.ifAdd = (value) =>{
            const reg = /^\s+$/gi;
            if(reg.test(value)){
                return true;
            }else {
                return false;
            }
        };
        // 验证身份证前四位
        Vue.prototype.ifAlphanumeric4 = (value) =>{
            const reg = /^[A-Za-z0-9]{1,4}$/;
            const reg1 = /^\s+$/gi;
			if(typeof value == 'undefined' || value == null || value == '' || reg.test(value) || reg1.test(value)){
				return false;
			}else{
                return true;
            }
			
        };
        // 验证邮箱
        Vue.prototype.ifEmail = (value) =>{
            const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
			if(!reg.test(value)){
				return true;
			}
			return false;
        };
        // 验证手机号码
        Vue.prototype.ifPhoneAndMobile = (value) =>{
            var reg = /(^(\d{3,4}-)?\d{7,8})$|(1[0-9]{10})/;
			if(!reg.test(value)){
				return true;
			}
			return false;
        };
        // 验证日期
        Vue.prototype.ifDay = (value) =>{
            var reg = /^0[1-9]$|^1[0-9]$|^2[0-9]$|^3[0-1]$/;
			if(!reg.test(value)){
				return true;
			}
			return false;
        };
        // 验证月份
        Vue.prototype.ifMonth = (value) =>{
            var reg = /^0[1-9]$|^1[0-2]$/;
			if(!reg.test(value)){
				return true;
			}
			return false;
        };
        // 验证年份
        Vue.prototype.ifYear = (value) =>{
            var reg = /^19\d{2}|20[0-1][0-9]$/;
			if(!reg.test(value)){
				return true;
			}
			return false;
        };
        // 验证姓氏
        Vue.prototype.ifSurname = (value) =>{
            // var reg = /^[\u4e00-\u9fa5 ]{1,200}$|^[a-zA-Z0-9 \/]{1,200}$/;
            var reg = /^[\s\S]{1,200}/;
			if(!reg.test(value)){
				return true;
			}
			return false;
        };
        // 无作用
        Vue.prototype.ifFun = (value) =>{
			return false;
        };
    }
}


// WEBPACK FOOTER //
// ./src/util/validation.js